import styled from "@emotion/styled";
import { Card, CardContent, css } from "@mui/material";

export const GridData = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
  gap: 10px;
  a {
    text-decoration: none;
    color: inherit;
  }
  > div {
    border-radius: 30px;
    text-align: center;
  }
`;

export const StyledCard = styled(Card)`
  padding: 40px 0px;
  height: 300px;
  min-width: 300px;
  border-radius: 25px;
  color: #114c97;
  transition: 0.5s;
  box-shadow: 0px 3px 6px #00000029;
  filter: grayscale(100%);
  ${(props) =>
    props.estado !== "deshabilitado" &&
    css`
      filter: grayscale(0%);
      :hover {
        transition: 0.5s;
        background-color: #114c97;
        color: floralwhite;
        cursor: pointer;
      }
    `}

  ${(props) => css`
    background-image: url(${props.image});
    background-position: center;
    background-size: 100%;
  `}
  :hover {
    background-size: 110%;
  }
`;
export const StyledCardContent = styled(CardContent)`
  display: flex;
  height: 80%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;
